import { useData, useDispatch } from "./DataContext.js";

import Card from "react-bootstrap/Card";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Button from "react-bootstrap/Button";
import ToggleButton from "react-bootstrap/ToggleButton";

import SimHome from "./SimHome.js";
import SimGroupList from "./SimGroupList.js";
import SimArticleList from "./SimArticleList.js";
import SimCourseList from "./SimCourseList.js";
import CardTitle from "./CardTitle.js";


const tabs = [
    { name: "sim", title: "Accueil" },
    { name: "groups", title: "Groupes" },
    { name: "articles", title: "Articles" },
    { name: "courses", title: "Cours" },
    /* { name: "test", title: "Test" }, */
];

export default function SimMain (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    const simTitle = gData.sim[gData.simID].title;
    const tabName = gData.tabName;

    function handleClose (tabName) { gDispatch({ type: "closeSim" }); }
    const closeButton = (<Button variant="outline-secondary" size="md" onClick={handleClose}>Fermer</Button>);

    function handleTab (tabName) { gDispatch({ type: "openTab", tabName: tabName }); }
    const tabButtonList = tabs.map(tab => (
	<ToggleButton
	    key={tab.name}
		type="radio"
		variant="outline-primary"
		name="radio"
		value="group"
		size="md"
		checked={tabName === tab.name}
		onClick={() => handleTab(tab.name)}
	>
	    {tab.title}
	</ToggleButton>
    ));

    return (
	<Card className="shadow-sm m-3 mb-5">
	    <Card.Header className="d-flex justify-content-between align-items-center">
		<CardTitle title={simTitle} subtitle="Simulation"/>
		<div className="d-flex gap-2">
		    <ButtonGroup>{tabButtonList}</ButtonGroup>
		    {closeButton}
		</div>
	    </Card.Header>
	    <Card.Body className="m-2">
		{tabName === "sim" && <SimHome/>}
		{tabName === "groups" && <SimGroupList/>}
		{tabName === "articles" && <SimArticleList/>}
		{tabName === "courses" && <SimCourseList/>}
	    </Card.Body>
	</Card>
    );
}
